import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  SimpleGrid,
  Flex,
  Icon,
  VStack,
  useColorModeValue,
  Badge,
} from '@chakra-ui/react';
import { FaBrain, FaRobot, FaChartLine, FaCode, FaDatabase, FaCloud } from 'react-icons/fa';

const Solutions: React.FC = () => {
  const bgGradient = useColorModeValue(
    'linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(124,58,237,0.05) 100%)',
    'linear-gradient(180deg, rgba(26,32,44,0) 0%, rgba(124,58,237,0.1) 100%)'
  );

  return (
    <Box py={20} pt="160px" position="relative" overflow="hidden" bgGradient={bgGradient}>
      <Container maxW="1200px" position="relative" zIndex={1}>
        <Box textAlign="center" mb={16}>
          <Badge
            colorScheme="purple"
            mb={4}
            px={3}
            py={1}
            borderRadius="full"
            fontWeight="bold"
          >
            全方位AI应用解决方案
          </Badge>
          <Heading
            as="h1"
            size={{ base: "2xl", md: "3xl" }}
            fontWeight="bold"
            mb={6}
            bgGradient="linear(to-r, brand.purple, brand.blue)"
            bgClip="text"
          >
            解决方案
          </Heading>
          <Text
            fontSize={{ base: "lg", md: "xl" }}
            color="gray.600"
            maxW="800px"
            mx="auto"
            mb={12}
          >
            Y-Square AI 提供从咨询、设计、开发到部署的全流程 AI 解决方案，帮助企业快速实现智能化转型
          </Text>
        </Box>

        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={10}>
          {solutions.map((solution, index) => (
            <VStack
              key={index}
              align="start"
              p={8}
              bg="white"
              borderRadius="xl"
              boxShadow="0 4px 20px rgba(0,0,0,0.05)"
              borderTop="4px solid"
              borderTopColor={solution.color}
              _hover={{
                transform: "translateY(-5px)",
                boxShadow: "0 10px 25px rgba(0,0,0,0.1)"
              }}
              transition="all 0.3s ease"
            >
              <Flex
                w="60px"
                h="60px"
                borderRadius="lg"
                justify="center"
                align="center"
                bg={solution.color}
                color="white"
                mb={4}
              >
                <Icon as={solution.icon} boxSize={6} />
              </Flex>
              <Heading as="h3" size="md" mb={3} color={solution.titleColor}>
                {solution.title}
              </Heading>
              <Text color="gray.600" lineHeight="1.8">
                {solution.description}
              </Text>
            </VStack>
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
};

const solutions = [
  {
    title: '自然语言处理解决方案',
    description: '基于先进的语言模型，为企业提供智能客服、文档理解、情感分析等自然语言处理服务，提升客户体验和业务效率。',
    icon: FaBrain,
    color: 'brand.purple',
    titleColor: 'brand.purple'
  },
  {
    title: '计算机视觉应用',
    description: '提供图像识别、物体检测、视频分析等视觉AI解决方案，广泛应用于安防监控、质量检测、零售分析等领域。',
    icon: FaRobot,
    color: 'brand.blue',
    titleColor: 'brand.blue'
  },
  {
    title: '智能决策系统',
    description: '结合机器学习和深度学习技术，开发智能推荐、风险预测、资源优化等决策支持系统，助力企业数据驱动决策。',
    icon: FaChartLine,
    color: 'brand.cyan',
    titleColor: 'brand.cyan'
  },
  {
    title: '智能流程自动化',
    description: '通过AI技术实现业务流程自动化，包括文档处理、数据提取、流程优化等，大幅提升工作效率和准确率。',
    icon: FaCode,
    color: 'purple.500',
    titleColor: 'purple.500'
  },
  {
    title: '知识图谱构建',
    description: '帮助企业构建行业知识图谱，实现知识管理、智能问答、关联分析等功能，挖掘数据深层价值。',
    icon: FaDatabase,
    color: 'blue.500',
    titleColor: 'blue.500'
  },
  {
    title: 'AI云服务平台',
    description: '提供易用的AI云服务平台，包括API服务、模型训练、数据标注等功能，降低AI应用门槛，加速企业AI落地。',
    icon: FaCloud,
    color: 'teal.500',
    titleColor: 'teal.500'
  },
];

export default Solutions;